
<template>
  <b-container>

    <div class="translations-backup-now-container">
      <h4
        style="float: left"
        class="translations-backup-now"
        @click="copyToLanguage()"
      >
        COPY TO LANGUAGES COLLECTION
      </h4>
      Your last language backup was on:
      <span v-if="backup"> {{ backup.backupDate | formatDateWithTime }}</span>
      <h4 class="translations-backup-now" @click="goToBackup()">BACKUP NOW</h4>
    </div>
    <b-row style="align-items: center">
      <b-col cols="2">
        <h3>Translations</h3>
      </b-col>
      <b-col>
        To publish your changes please regenerate language cache:
        <h2 class="translations-go-live" @click="goToRegenerate()">GO LIVE</h2>
      </b-col>
      <b-col cols="2">
        <span>Show Results</span>
        <b-form-group>
          <b-form-select v-model="perPage" @change="getLabelsData()">
            <option value="10">10</option>
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </b-form-select>
        </b-form-group>
      </b-col>
      <b-col cols="1">
        <b-button
          class="translations-button-outline"
          variant="primary"
          @click="newModal()"
        >
          New
        </b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-table
          show-empty
          striped
          hover
          bordered
          :fields="tableHeader"
          :items="tableData"
          :per-page="0"
          :current-page="1"
        >
          <template #thead-top="">
            <b-tr>
              <b-td v-for="(lang, index) in tableHeader" :key="index">
                <b-input-group>
                  <template #append>
                    <span
                      ><icon
                        class="fa-icon-nuevo"
                        name="search"
                        aria-hidden="true"
                        @click="getLabelsData()"
                    /></span>
                  </template>
                  <b-form-input
                    v-model="searchTerm[index]"
                    class="input__nuevo translations-input"
                    type="text"
                    :placeholder="
                      $t('label_administration_localization_search_placeholder')
                    "
                    @input="getLabelsData()"
                  />
                </b-input-group>
              </b-td>
            </b-tr>
            <b-tr>
              <b-td v-for="(lang, index) in tableHeader" :key="index">
                <span v-if="index === 0">
                  {{ lang }}
                </span>
                <span v-else>
                  <b-form-select
                    v-model="selectedLanguages[index - 1]"
                    :options="getOptionsLanguage(index)"
                  />
                  <b-button
                    style="margin-top: 10px"
                    @click="copyNewLabels(lang)"
                    >Sync New Labels</b-button
                  >
                </span>
              </b-td>
            </b-tr>
          </template>

          <template #head()="">
            <div />
          </template>

          <template #cell()="data">
            <div
              v-if="data.value && !data.value.translation"
              style="min-width: 300px; word-break: break-all"
              @click="editModal(data)"
            >
              {{ data.value }}
            </div>
            <div
              v-if="data.value && data.value.translation"
              style="min-width: 300px; word-break: break-all"
              @click="editModal(data)"
            >
              {{ data.value.translation }}
            </div>
          </template>
        </b-table>
      </b-col>
    </b-row>
    <b-row>
      <b-col />
      <b-col>
        <b-pagination
          v-model="currentPage"
          align="center"
          :total-rows="totalRows"
          :per-page="perPage"
          aria-controls="my-table"
          @input="getLabelsData()"
        />
      </b-col>
      <b-col col />
    </b-row>
    <b-modal
      id="modalInfo"
      v-model="showModalEdit"
      modal-class="modalInfo"
      :title="$t('label_administration_localization_editLabel')"
    >
      <b-form @submit.prevent="">
        <b-form-group label-class="text-sm-left">
          <template slot="label">
            <!--title-->
            {{ $t("label_administration_localization_labels") }}
          </template>
          <b-form-input
            id="label_administration_localization_labels"
            v-model="model.label"
            type="text"
            required
          />
        </b-form-group>
        <b-form-group
          v-for="(item, index) in model.items"
          :key="index"
          label-class="text-sm-left"
        >
          <template slot="label">
            <!--title-->
            {{ $t("label_administration_localization_" + item.identifier) }}
          </template>
          <b-form-input
            id="label_administration_localization_labels"
            v-model="item.value"
            type="text"
            required
          />
        </b-form-group>
      </b-form>
      <div slot="modal-footer" class="w-100" style="text-align: right">
        <b-btn variant="primary" @click="insertOrUpdate()">
          {{ $t("label_administration_localization_save") }}
        </b-btn>
        <b-btn variant="primary" @click="closeModal()">
          {{ $t("label_administration_localization_cancel") }}
        </b-btn>
      </div>
    </b-modal>
  </b-container>
</template>


<script>
import Vue from "vue";
import Icon from "vue-awesome/components/Icon";
import "vue-awesome/icons";

import "@/assets/icons/icons";
import { axiosCall } from "../../../../utils/axiosCall";

Vue.component("Icon", Icon);

export default {
  name: "LabelsManagement",
  data: function () {
    return {
      searchTerm: [],
      availableLanguages: [],
      selectedLanguages: [],
      model: {},
      currentPage: 1,
      totalRows: 1,
      perPage: 10,
      tableData: [],
      tableHeader: [],
      cant: 50,
      editMode: false,

      backup: {},
      tableElements: {},
      showModalEdit: false,
    };
  },
  computed: {},
  watch: {
    selectedLanguages: {
      handler: async function () {
        this.tableHeader = ["label", ...this.selectedLanguages];
        await this.getLabelsData();
      },
      deep: true,
    },
  },
  created: async function () {
    await this.getAvailableLanguages();
    await this.getLastBackup();
  },
  mounted: function () {},
  methods: {
    goToBackup() {
      this.$router.push("/LabelsBackup");
    },
    goToRegenerate() {
      this.$router.push("/LabelsRegenerateCache");
    },
    getLastBackup: async function () {
      await axiosCall({
        url: "LabelBackups/GetLastBackup",
        method: "GET",
      }).then(async (response) => {
        this.backup = response.data;
      });
    },
    getOptionsLanguage(index) {
      let indexOther = index === 1 ? 1 : 0;
      return this.availableLanguages.filter(
        (option) => option.value !== this.selectedLanguages[indexOther]
      );
    },
    closeModal() {
      this.showModalEdit = false;
    },
    insertOrUpdate() {
      const url = `/Labels/insertOrUpdate`;
      const data = this.model;
      data.editMode = this.editMode;
      axiosCall({ url, method: "post", data })
        .then(() => {
          this.getLabelsData();
          this.showModalEdit = false;
        })
        .catch(() => {
          alert("Error Guardando el Label");
        });
    },
    newModal() {
      this.model.items = [];
      this.model.label = "";
      this.tableHeader.map((key) => {
        if (key !== "label") {
          this.model.items.push({ identifier: key, value: "" });
        }
      });
      this.showModalEdit = true;
    },
    editModal(label) {
      this.model.items = [];
      this.model.label = label.item.label;
      this.model.items.push({
        identifier: this.selectedLanguages[0],
        value: label.item[this.selectedLanguages[0]]?.translation,
      });
      this.model.items.push({
        identifier: this.selectedLanguages[1],
        value: label.item[this.selectedLanguages[1]]?.translation,
      });

      this.showModalEdit = true;
      this.editMode = true;
    },
    async getAvailableLanguages() {
      const url = `/Langs/AvailableLanguages`;
      await axiosCall({ url: url }).then((response) => {
        this.availableLanguages = response.data.map((avL) => {
          return {
            text: avL.language,
            value: avL.id,
          };
        });

        const preferredLanguages = [...this.availableLanguages].sort((a, b) => {
          const order = { en: 0, es: 1 };
          return (order[a.value] ?? 99) - (order[b.value] ?? 99);
        });

        this.selectedLanguages = [
          preferredLanguages[0].value,
          preferredLanguages[1].value,
        ];
        this.tableHeader = ["label", ...this.selectedLanguages];
      });
    },
    async copyToLanguage() {
      const url = `/Labels/copyToLanguage`;
      await axiosCall({ url: url }).then(() => {
      });
    },
    async getLabelsData() {
      const url = `/Labels/FindLabel?label_name=${
        this.searchTerm[0] || ""
      }&first_language=${this.selectedLanguages[0] || ""}&second_language=${
        this.selectedLanguages[1] || ""
      }&first_language_term=${this.searchTerm[1] || ""}&second_language_term=${
        this.searchTerm[2] || ""
      }&page=${this.currentPage}&page_size=${this.perPage}`;
      await axiosCall({ url: url }).then((response) => {
        const results = response.data.results;
        this.tableData = Object.values(results);
        this.totalRows = response.data.totalRows;
      });
    },
    async copyNewLabels(language) {
      const url = `/Labels/copyNewLabels/${language}`;
      await axiosCall({ url: url }).then((response) => {
        alert(response.data + " labels sync");
        this.getLabelsData();
      });
    },
  },
};
</script>
<style lang="scss">
.input-group-append {
  display: flex;
  align-items: center;
  position: absolute;
  right: 10px;
  top: 9px;
  z-index: 4;
}
.translations {
  &-backup-now {
    color: #a70404;
    text-decoration: underline;
    cursor: pointer;
    display: inline-block;
    margin-left: 7px;
    &-container {
      text-align: right;
    }
  }
  &-input {
    border-radius: 10px;
    border-top-right-radius: 10px !important;
    border-bottom-right-radius: 10px !important;
  }
  &-go-live {
    color: #1e4380;
    cursor: pointer;
    display: inline-block;
    margin-left: 7px;
  }
  &-button-outline {
    padding: 5px 15px;
    border-radius: 5px !important;
    margin-right: 15px;
    background-color: white !important;
    border-width: 2px;
    color: #1e4380 !important;
  }
}
</style>
